import React, { useState, useEffect, useContext,useCallback, Fragment } from 'react';
import Images from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import Layout from 'components/sales/layout/layout';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import 'react-toastify/dist/ReactToastify.css';
import { Link } from 'react-router-dom';
import TableSection from 'components/sales/tableSection/tableSection';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import {Button} from "react-bootstrap";

const FinanceMrfListing = ({
  fetchMrfList,
  mrfListingFinance = [],
  dropDownForMrfType,
  mrfTypeDropdown = []
}) => {
  const [isFiled, setIsFiled] = useState(false);
  const { baseUrl } = useContext(BaseUrl);
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState();
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);

  const Headers = [
    'MRF No.',
    'Project Id',
    'Project Name',
    'Site No.',
    'Type',
    'Planned Delivery Date',
    'Status',
    'Created By',
    'Created At',
    'Action',
  ];

  useEffect(() => {
    (async () => {
        setIsLoading(true)
        fetchMrfList(1)
        setIsLoading(false)
    })()
  }, [])

  useEffect(() => {

    const tableData = [
        'mrf_id',
        'infra_project_id',
        'client_name',
        'site_id',
        'mrf_type',
        'planned_delivery_date',
        'status_string',
        'created_by',   
    ];

    if (mrfListingFinance && mrfListingFinance?.data) {
      const data = mrfListingFinance?.data?.map((element) =>
        Object.assign(
          {},
          ...tableData.map((key) => ({ [key]: element[key] })),
          {
            created_ats: element.created_at,
            Action: [
              {
                name: "View Details",
                link: `/dashboard/mrf-finance-view/${element.mrf_id}`
              },
            ],
          }
        )
      );

      if (data.length > 0) {
        setListData(data);
      } else {
        setListData([]);
      }

      setPageCount(
        Math.ceil(mrfListingFinance?.total / mrfListingFinance?.per_page)
      );
    }
  }, [mrfListingFinance]);


  const filterToggle = () => {
    setShowFilter(!showFilter);
    setIsLoading(true)
    dropDownForMrfType()
    setIsLoading(false)
  };

  const applyFilter = async (filterData) => {
    console.log("filter Data:", filterData);
    setIsLoading(true);
    setFilterData(filterData);
    await fetchMrfList(1,filterData);
    setIsLoading(false);
    filterToggle();
  };

  const headerBtns = () => {
    return (
      <Fragment>
        {/* <Link
          to={{
            pathname: `${baseUrl}/finance-add-business`,
          }}
          className="btn btn-primary d-md-inline-block"
        >
          {localization.addBusiness}
          <img src={Images?.ArrowRight} alt="" />
        </Link> */}
        <Button
            onClick={filterToggle}
            className="filter-hamburger filter-btn btn btn-transparent"
        >
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
        
    </Fragment>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await fetchMrfList(val.selected + 1, filter);
    setIsLoading(false);
  };

  return (
    <Layout
      title={'MRF Listing'}
      Buttons={headerBtns}
      //isGoback
      isLoading={isLoading}
      //linkUrl={`${baseUrl}/brand-activation/conduct-camp/camp`}
    >
      <TableSection
          data={listData}
          headers={Headers}
          pageCount={pageCount}
          srNo={mrfListingFinance?.from}
          onPageChange={onPageChange}
          isId={false}
          detailList={mrfListingFinance && mrfListingFinance.resultSets}
      />

      <ListFilters
          showFilter={showFilter}
          filterToggle={filterToggle}
          applyFilter={(val) => applyFilter(val)}
          listFilterData={mrfTypeDropdown}
          financeMrfFilter
          projectOnboardingStatus={true}
      />

    </Layout>
  );
};

FinanceMrfListing.propTypes = {};

export default FinanceMrfListing;
